import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { LocationsTranslationCountersHttpClient } from './locations-translation-counters.http-client';
import { LocationTranslationCountersActions } from './locations-translation-counters.store';

@Injectable({ providedIn: 'root' })
export class LocationsTranslationCountersEffects {
  public effects = createEffectFactory(LocationTranslationCountersActions, this.actions$);

  public fetch$ = this.effects(LocationTranslationCountersActions.fetchCollection, ({ payload }) =>
    this.http.fetch(payload.scope).pipe(map(data => ({ data, scope: payload.scope }))),
  );

  constructor(
    private actions$: Actions,
    private http: LocationsTranslationCountersHttpClient,
  ) {}
}
